export default __webpack_public_path__ + "images/e4fae75e42bdf447e3b0618bb157ee1a-valentine_touchpoint.webp";